var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#070A0E;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00D395;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.9,881.1c243.3,0,440.6-197.3,440.6-440.6S683.3-0.1,439.9-0.1S-0.7,197.2-0.7,440.5 S196.6,881.1,439.9,881.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.9,588.3c-13.2-8.1-21.2-22.4-21.2-37.8v-86.1c0-10.2,8.3-18.5,18.5-18.5c3.3,0,6.5,0.9,9.3,2.5 l194.3,113.3c11.4,6.6,18.4,18.8,18.4,31.9v89.2c0,12.2-9.9,22.2-22.1,22.2c-4.1,0-8.2-1.1-11.6-3.3L253.9,588.3z M543.4,424.8 c11.4,6.6,18.3,18.8,18.4,31.9v181c0,5.3-2.9,10.3-7.5,12.9l-42.5,23.9c-0.5,0.3-1.1,0.5-1.7,0.7V574.8c0-13-6.8-25.1-18-31.8 L321.4,441V327.5c0-10.2,8.3-18.5,18.5-18.5c3.3,0,6.5,0.9,9.3,2.5L543.4,424.8z M628.5,291.2c11.4,6.6,18.4,18.8,18.4,32v264.4 c0,5.4-3,10.4-7.8,13l-40.3,21.8v-184c0-13-6.8-25-17.9-31.7L406.4,301.9V194.3c0-3.3,0.9-6.5,2.5-9.3c5.2-8.8,16.5-11.8,25.3-6.7 L628.5,291.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompIcon);
export default __webpack_public_path__ + "static/media/comp_icon.69278a8a185f11855356f62253f3c7b7.svg";
export { ForwardRef as ReactComponent };